/**
 * gem-modal.js  v43
 *
 * v42からの変更点:
 *   - findStoneImage() のDOMサーチで stoneCode・size も検索キーに含めるよう修正。
 *     v42では '-{stoneNum}-' のみで検索していたため、ページ内に複数石種の画像が
 *     存在する場合（例：ppとgoが混在）に別石種の -stone 画像が誤ってヒットする
 *     不具合があった。Safari で特定の石のモーダルに別の石の画像が表示される原因。
 *     修正後は '-{stoneCode}-{size}-{stoneNum}-' で検索するため誤マッチを防ぐ。
 */

(function () {
  'use strict';

  /* -------------------------------------------------------
     グレードコメント定義
     星の数（1〜5）ごとに固定コメントを設定。
     変更する場合はこのオブジェクトを編集してください。
  ------------------------------------------------------- */

  var GEM_GRADE_COMMENTS = {
    'カラー': {
      '5':   '豊かで深みを感じさせる素晴らしいカラーです',
      '4.5': '非常に美しく鮮やかなカラーです',
      '4':   '美しく鮮やかなカラーです',
      '3.5': '良好で魅力的なカラーです',
      '3':   '良好なカラーです',
      '2.5': '標準的なカラーです',
      '2':   '標準的なカラーです',
      '1.5': '個性的な色合いです',
      '1':   '個性的な色合いです',
    },
    '透明感とインクル': {
      '5':   '非常に高い透明度で、インクルージョンはほぼ見られません',
      '4.5': '高い透明度で、ごくわずかなインクルージョンが見られます',
      '4':   '高い透明度で、わずかなインクルージョンが見られます',
      '3.5': '透明感があり、わずかなインクルージョンが認められます',
      '3':   '透明感があり、細かいインクルージョンが認められます',
      '2.5': 'やや内包物が見られます',
      '2':   'やや内包物が目立ちます',
      '1.5': '内包物が多めで独特の表情があります',
      '1':   '内包物が多めで独特の表情があります',
    },
  };

  var GEM_GRADE_KEYS = ['カラー', '透明感とインクル'];

  /* -------------------------------------------------------
     半星HTML生成ヘルパー
  ------------------------------------------------------- */

  function buildStarsHtml(score) {
    var stars = '';
    for (var s = 1; s <= 5; s++) {
      if (score >= s) {
        stars += '<span class="gem-grade__star gem-grade__star--on">★</span>';
      } else if (score >= s - 0.5) {
        stars += '<span class="gem-grade__star gem-grade__star--half">★</span>';
      } else {
        stars += '<span class="gem-grade__star gem-grade__star--off">★</span>';
      }
    }
    return stars;
  }

  /* -------------------------------------------------------
     gradeStr のパース
  ------------------------------------------------------- */

  function parseGradeStr(gradeStr) {
    if (!gradeStr || !gradeStr.trim()) return null;

    var isItten = gradeStr.indexOf(':') !== -1;
    var parts   = gradeStr.split(',');

    return parts.map(function (part) {
      part = part.trim();
      if (isItten) {
        var colonIdx = part.indexOf(':');
        var scoreStr = colonIdx !== -1 ? part.slice(0, colonIdx).trim() : part;
        var text     = colonIdx !== -1 ? part.slice(colonIdx + 1).trim() : '';
        return { score: parseFloat(scoreStr), text: text, isItten: true };
      } else {
        return { score: parseFloat(part), text: null, isItten: false };
      }
    }).filter(function (item) {
      return !isNaN(item.score) && item.score >= 1 && item.score <= 5;
    });
  }

  /* -------------------------------------------------------
     グレードHTML生成
  ------------------------------------------------------- */

  function buildGradeHtml(gradeStr) {
    if (!gradeStr || !gradeStr.trim()) return '';

    var items = parseGradeStr(gradeStr);
    if (!items || items.length === 0) return '';

    var rows = GEM_GRADE_KEYS.map(function (key, i) {
      var item = items[i];
      if (!item) return '';

      var score  = item.score;
      var stars  = buildStarsHtml(score);
      var comment;

      if (item.isItten) {
        comment = item.text || '';
      } else {
        var key2 = String(score % 1 === 0 ? score.toFixed(0) : score);
        comment = (GEM_GRADE_COMMENTS[key] && GEM_GRADE_COMMENTS[key][key2]) || '';
      }

      return '<div class="gem-grade__row">'
        + '<div class="gem-grade__label">' + key + '</div>'
        + '<div class="gem-grade__stars">' + stars + '</div>'
        + '<div class="gem-grade__comment">' + comment + '</div>'
        + '</div>';
    });

    var inner = rows.filter(Boolean).join('');
    if (!inner) return '';

    return '<div class="gem-grade">' + inner + '</div>';
  }

  /* -------------------------------------------------------
     ユーティリティ
  ------------------------------------------------------- */

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function parseOriginalText(raw) {
    if (!raw) return { name: '', subtext: '', stoneNum: '', stockNum: '', isTokka: false };

    var work = raw;
    var stoneNum = '';
    var isTokka = false;

    // ▼ [000] 形式の3桁番号を最優先で取得（汎用石・1点もの共通）
    var numTagMatch = work.match(/\[(\d{3})\]/);
    if (numTagMatch) {
      stoneNum = numTagMatch[1];
      work = work.replace(numTagMatch[0], '').trim();
    }

    // [stockX] は画像切り替え用。石画像取得にも使うため値を保持する
    var stockNum = '';
    var stockMatch = work.match(/\[stock(\w+)\]/i);
    if (stockMatch) {
      stockNum = 'stock' + stockMatch[1];
      work = work.replace(stockMatch[0], '').trim();
    }

    if (work.indexOf('[特価]') !== -1) {
      isTokka = true;
    }

    work = work.replace(/\[[^\]]*\]/g, '').trim();

    var itten = '';
    var ittenMatch = work.match(/1点もの\s*#(\d+)/);
    if (ittenMatch) {
      itten = '1点もの#' + ittenMatch[1];
      if (!stoneNum) stoneNum = ittenMatch[1];
      work = work.replace(ittenMatch[0], '').trim();
    }

    var subParts = [];
    var ctMatch = work.match(/([\d.]+[Cc][Tt](?:前後)?)/);
    if (ctMatch) {
      subParts.push(ctMatch[0]);
      work = work.replace(ctMatch[0], '').trim();
    }

    var sizeMatch = work.match(/約?[\d.]+×[\d.]+mm/);
    if (sizeMatch) {
      subParts.push(sizeMatch[0]);
      work = work.replace(sizeMatch[0], '').trim();
    }

    var stoneName = work.trim();
    var nameLine  = stoneName + (itten ? '　' + itten : '');
    var subtext   = subParts.join('　');

    return { name: nameLine, subtext: subtext, stoneNum: stoneNum, stockNum: stockNum, isTokka: isTokka };
  }

  function buildNoteHtml(noteStr, prefix) {
    if (!noteStr || !noteStr.trim()) return '';

    var pills = noteStr.split(',')
      .map(function (item) { return item.trim(); })
      .filter(Boolean)
      .map(function (item) {
        var parts = item.split('=');
        var label = parts[0] ? parts[0].trim() : item;
        var mark  = parts[1] ? parts[1].trim() : '';
        var cls   = mark === '○'
          ? prefix + '__note-pill--good'
          : prefix + '__note-pill--fair';
        return '<span class="' + prefix + '__note-pill ' + cls + '">'
          + label + '&nbsp;' + mark
          + '</span>';
      })
      .join('');

    return '<div class="' + prefix + '__note-label">地金との相性</div>'
      + '<div class="' + prefix + '__note-pills">' + pills + '</div>';
  }

  /* -------------------------------------------------------
     メイン画像URL取得（PC用・フォールバック）
  ------------------------------------------------------- */

  function getMainImageSrc() {
    var allImgs = document.querySelectorAll('img');
    for (var i = 0; i < allImgs.length; i++) {
      var src = allImgs[i].src || '';
      if (src.indexOf('apo-admin.mageworx.com') !== -1) return src;
    }
    var fallbacks = [
      'img.zoomImg',
      '.rimage__image',
      '.product-media--image img',
      '.product-media img',
      '.product__media img',
      '.product-gallery img',
    ];
    for (var j = 0; j < fallbacks.length; j++) {
      var el = document.querySelector(fallbacks[j]);
      if (el && el.src && el.src.indexOf('data:') === -1) return el.src;
    }
    return '';
  }

  /* -------------------------------------------------------
     APOスウォッチDOMから gem データ取得
  ------------------------------------------------------- */

  function getGemData(valueId, fallbackImgSrc) {
    var container = document.querySelector('.mw-option__value[data-value-id="' + valueId + '"]');
    if (!container) {
      return { name: '', subtext: '', price: '', image: fallbackImgSrc || '', descHtml: '', noteStr: '', gradeStr: '' };
    }

    var nameEl  = container.querySelector('[data-original-text]');
    var rawText = nameEl ? nameEl.getAttribute('data-original-text') : '';
    var parsed  = parseOriginalText(rawText);

    var priceEl = container.querySelector('.mw-option__price, .mw-text.mw-option__price');
    var price   = priceEl ? priceEl.textContent.trim().replace(/^[+＋]\s*/, '') : '';

    var variantDesc = '';
    if (parsed.stoneNum) {
      var variantDescEl = document.querySelector('#gemVariantDescs [data-stone-num="' + parsed.stoneNum + '"]');
      if (variantDescEl) {
        var variantDescText = variantDescEl.textContent.trim();
        variantDesc = variantDescText ? variantDescEl.innerHTML.trim() : '';
      }
    }

    var descEl     = document.getElementById('gemProductDesc');
    var commonDesc = descEl ? descEl.innerHTML.trim() : '';

    var gradeStr = '';
    if (parsed.stoneNum) {
      var gradeDescEl = document.querySelector('#gemVariantDescs [data-stone-num="' + parsed.stoneNum + '"]');
      gradeStr = gradeDescEl ? (gradeDescEl.getAttribute('data-stone-grade') || '') : '';
    }

    var descHtml = '';
    if (variantDesc) {
      descHtml += '<div class="gem-modal__variant-desc">' + variantDesc + '</div>';
      descHtml += buildGradeHtml(gradeStr);
      if (commonDesc) {
        descHtml += commonDesc;
      }
    } else {
      descHtml = buildGradeHtml(gradeStr) + commonDesc;
    }

    var noteEl  = document.getElementById('gemProductNote');
    var noteStr = noteEl ? noteEl.textContent.trim() : '';

    return {
      name:     parsed.name,
      subtext:  parsed.subtext,
      price:    price,
      image:    fallbackImgSrc || '',
      descHtml: descHtml,
      noteStr:  noteStr,
      gradeStr: gradeStr,
      isTokka:  parsed.isTokka,
    };
  }

  /* -------------------------------------------------------
     モーダルにデータを流し込む
  ------------------------------------------------------- */

  function populateModal(data) {
    var imgHtml = data.image
      ? '<img src="' + data.image + '" alt="' + (data.name || '') + '" style="width:100%;height:100%;object-fit:contain;">'
      : '';

    var modalImgArea = document.getElementById('gemModalImageArea');
    if (modalImgArea) modalImgArea.innerHTML = imgHtml;

    var el;
    el = document.getElementById('gemModalName');  if (el) el.textContent = data.name    || '';
    el = document.getElementById('gemModalSub');   if (el) el.textContent = data.subtext || '';

    el = document.getElementById('gemModalPrice');
    if (el) {
      var modalWrap = document.getElementById('gemModalPriceWrap');
      var modalBadge = modalWrap ? modalWrap.querySelector('.gem-modal__tokka-badge') : null;
      if (modalBadge) modalBadge.remove();
      el.textContent = data.price || '';
      if (data.isTokka && el.parentNode) {
        var badge = document.createElement('span');
        badge.className = 'gem-modal__tokka-badge';
        badge.textContent = '特価';
        el.parentNode.insertBefore(badge, el);
      }
    }

    el = document.getElementById('gemModalDesc');  if (el) el.innerHTML = data.descHtml || '';
    el = document.getElementById('gemModalNote');  if (el) el.innerHTML = buildNoteHtml(data.noteStr, 'gem-modal');

    // ボトムシート
    var sheetImgArea = document.getElementById('gemSheetImageArea');
    if (sheetImgArea) sheetImgArea.innerHTML = imgHtml;

    el = document.getElementById('gemSheetName');  if (el) el.textContent = data.name    || '';
    el = document.getElementById('gemSheetSub');   if (el) el.textContent = data.subtext || '';

    el = document.getElementById('gemSheetPrice');
    if (el) {
      var sheetWrap = document.getElementById('gemSheetPriceWrap');
      var sheetBadgeEl = sheetWrap ? sheetWrap.querySelector('.gem-modal__tokka-badge') : null;
      if (sheetBadgeEl) sheetBadgeEl.remove();
      el.textContent = data.price || '';
      if (data.isTokka && el.parentNode) {
        var sheetBadge = document.createElement('span');
        sheetBadge.className = 'gem-modal__tokka-badge';
        sheetBadge.textContent = '特価';
        el.parentNode.insertBefore(sheetBadge, el);
      }
    }

    el = document.getElementById('gemSheetDesc');  if (el) el.innerHTML = data.descHtml || '';
    el = document.getElementById('gemSheetNote');  if (el) el.innerHTML = buildNoteHtml(data.noteStr, 'gem-sheet');
  }

  /* -------------------------------------------------------
     石画像エリアだけを差し替える（モーダル開後に呼ぶ）
  ------------------------------------------------------- */

  function replaceModalImage(src, altText) {
    var imgHtml = '<img src="' + src + '" alt="' + (altText || '') + '" style="width:100%;height:100%;object-fit:contain;">';
    var modalImgArea = document.getElementById('gemModalImageArea');
    var sheetImgArea = document.getElementById('gemSheetImageArea');
    if (modalImgArea) modalImgArea.innerHTML = imgHtml;
    if (sheetImgArea) sheetImgArea.innerHTML = imgHtml;
  }

  /* -------------------------------------------------------
     開閉
  ------------------------------------------------------- */

  function openModal(data) {
    populateModal(data);
    if (isMobile()) {
      document.getElementById('gemSheetOverlay').classList.add('is-open');
    } else {
      document.getElementById('gemModalOverlay').classList.add('is-open');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeModal(e) {
    if (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
    }
    var mo = document.getElementById('gemModalOverlay');
    var so = document.getElementById('gemSheetOverlay');
    if (mo) mo.classList.remove('is-open');
    if (so) so.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* -------------------------------------------------------
     ⓘ ボタン注入
  ------------------------------------------------------- */

  var injected = new Set();

  function getStoneOptionIds() {
    var ids = [];
    var options = document.querySelectorAll('.mw-option[data-option-id]');
    options.forEach(function (option) {
      var title = option.querySelector('.mw-option__title, .mw-label, [class*="title"]');
      if (title && title.textContent.indexOf('お石') !== -1) {
        ids.push(option.getAttribute('data-option-id'));
      }
    });
    return ids;
  }

  /**
   * 石単体画像（-stone.png）のURLを非同期で取得する。
   *
   * v43: DOMサーチのキーを '-{stoneCode}-{size}-{stoneNum}-' に変更。
   *      v42では '-{stoneNum}-' のみで検索していたため、ページ内に複数石種の
   *      画像が混在する場合に別石種の -stone 画像が誤ってヒットする不具合があった。
   *
   * ① DOMのimg[src*="cdn/shop/files"]から stoneCode・size・stoneNum をすべて含む
   *    -stone URLを探す（1点ものはページ内の商品画像に既に存在することが多い）
   * ② DOMにない場合、サフィックスなしURLをfetch HEADして存在確認
   * ③ どちらも失敗したらnullを返す
   *
   * @param {string}   stoneNum - 'stock1' または '001' など
   * @param {function} callback - function(url|null)
   */
  function findStoneImage(stoneNum, callback) {
    var config = window.GEM_SWAP_CONFIG;
    if (!config || !stoneNum) {
      callback(null);
      return;
    }

    // ▼ v43修正: stoneCode・size も含めて絞り込む（別石種の誤ヒット防止）
    var stoneCode = (config.stoneCode || '').toLowerCase();
    var size      = (config.size      || '').toLowerCase();
    var key       = '-' + stoneCode + '-' + size + '-' + stoneNum.toLowerCase() + '-';

    // ① DOMから探す（srcset → src の順）
    var allImgs = document.querySelectorAll('img[src*="cdn/shop/files"]');
    for (var i = 0; i < allImgs.length; i++) {
      var imgEl = allImgs[i];
      // srcsetを優先
      var srcset = imgEl.getAttribute('srcset') || imgEl.getAttribute('data-srcset') || '';
      var src = '';
      if (srcset) {
        src = srcset.split(',')[0].trim().split(' ')[0];
      }
      if (!src) src = imgEl.src || '';
      if (!src) continue;

      var filename = src.split('?')[0].split('/').pop().toLowerCase();
      if (filename.indexOf(key) !== -1 && filename.indexOf('-stone') !== -1) {
        // クエリパラメータを除いたURLを返す
        callback(src.split('?')[0]);
        return;
      }
    }

    // ② fetchで存在確認（サフィックスなしURL）
    var baseFilename = [
      config.prefix || 'fioreovale',
      config.stoneCode,
      config.size,
      stoneNum,
      'stone'
    ].join('-') + '.png';

    var baseUrl = 'https://' + window.location.hostname + '/cdn/shop/files/' + baseFilename;

    fetch(baseUrl, { method: 'HEAD' })
      .then(function (r) {
        if (r.ok) {
          callback(baseUrl);
        } else {
          console.warn('[gem-modal] stone画像が見つかりません:', baseUrl);
          callback(null);
        }
      })
      .catch(function () {
        console.warn('[gem-modal] stone画像fetchエラー:', baseUrl);
        callback(null);
      });
  }

  function injectInfoButtons() {
    var stoneOptionIds = getStoneOptionIds();
    if (stoneOptionIds.length === 0) return;

    var selector = stoneOptionIds.map(function (id) {
      return '.mw-option[data-option-id="' + id + '"] .mw-option__value[data-value-id]';
    }).join(', ');

    var containers = document.querySelectorAll(selector);

    containers.forEach(function (container) {
      var valueId = container.getAttribute('data-value-id');
      if (!valueId || injected.has(valueId)) return;
      injected.add(valueId);

      var swatchImg = container.querySelector('img.mw-option__swatch-image')
                   || container.querySelector('img.mw-stack--card__media-wrapper--item')
                   || container.querySelector('.mw-option__swatch-media img')
                   || container.querySelector('img');
      var swatchSrc = swatchImg ? swatchImg.src : '';

      var btn = document.createElement('button');
      btn.className = 'gem-info-btn';
      btn.textContent = 'ステータス';
      btn.type = 'button';
      btn.setAttribute('aria-label', '宝石の詳細を見る');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        var nameEl = container.querySelector('[data-original-text]');
        var rawText = nameEl ? nameEl.getAttribute('data-original-text') : '';
        var parsed = parseOriginalText(rawText);

        // 汎用石は stockNum（例:stock1）を優先、1点ものは stoneNum（例:001）を使用
        var imageKey = parsed.stockNum || parsed.stoneNum;

        // ① まずスウォッチ画像でモーダルをすぐ開く（ユーザーを待たせない）
        var data = getGemData(valueId, swatchSrc || getMainImageSrc());
        openModal(data);

        // ② 石単体画像（-stone.png）を非同期で取得して差し替える
        if (imageKey) {
          findStoneImage(imageKey, function (stoneImgSrc) {
            if (!stoneImgSrc) return;
            replaceModalImage(stoneImgSrc, data.name);
          });
        }
      });

      if (window.getComputedStyle(container).position === 'static') {
        container.style.position = 'relative';
      }

      var swatchMedia = container.querySelector('.mw-option__swatch-media');
      if (swatchMedia) {
        swatchMedia.style.overflow = 'visible';
      }

      container.appendChild(btn);
    });
  }

  /* -------------------------------------------------------
     イベントバインド
  ------------------------------------------------------- */

  function bindEvents() {
    function safeClose(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', closeModal);
    }
    safeClose('gemModalClose');
    safeClose('gemSheetClose');

    var mo = document.getElementById('gemModalOverlay');
    if (mo) mo.addEventListener('click', function (e) {
      if (e.target === mo) closeModal(e);
    });

    var so = document.getElementById('gemSheetOverlay');
    if (so) so.addEventListener('click', function (e) {
      if (e.target === so) closeModal(e);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* -------------------------------------------------------
     スマホ時　お石 2列
  ------------------------------------------------------- */

  function applyStoneGridLayout() {
    var stoneOptionIds = getStoneOptionIds();
    stoneOptionIds.forEach(function (id) {
      var option = document.querySelector('.mw-option[data-option-id="' + id + '"]');
      if (!option) return;

      var valuesEl = option.querySelector('.mw-option__container-horizontal');
      if (!valuesEl) return;

      valuesEl.style.display = 'flex';
      valuesEl.style.flexWrap = 'wrap';
      valuesEl.style.gap = '12px';

      var allValues = option.querySelectorAll('.mw-option__value');

      var visibleCount = 0;
      allValues.forEach(function (v) {
        if (v.style.display !== 'none') visibleCount++;
      });

      allValues.forEach(function (v) {
        if (visibleCount <= 1) {
          v.style.width = '';
          v.style.maxWidth = '';
        } else {
          v.style.width = 'calc(50% - 6px)';
          v.style.maxWidth = 'calc(50% - 6px)';
        }
        v.style.height = 'auto';
        v.style.flexShrink = '0';
      });
    });
  }

  /* -------------------------------------------------------
     MutationObserver / 公開API / 初期化
  ------------------------------------------------------- */

  function observeApo() {
    var target = document.querySelector('form[action="/cart/add"]') || document.body;
    new MutationObserver(function () {
      injectInfoButtons();
      applyStoneGridLayout();
    }).observe(target, { childList: true, subtree: true });
  }

  window.gemModal = { open: openModal, close: closeModal };

  function init() {
    bindEvents();
    injectInfoButtons();
    observeApo();
    applyStoneGridLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();